import { tv } from '../tv';

export const orgSwitcherVariants = tv({
  slots: {
    trigger: `flex cursor-pointer items-center text-left
      transition-colors duration-200 ease-out motion-reduce:transition-none
      hover:bg-zinc-800 focus-visible:outline-2 focus-visible:outline-offset-2
      focus-visible:outline-zinc-50 aria-expanded:bg-zinc-800`,
    text: 'flex min-w-0 flex-col',
  },
  variants: {
    compact: {
      true: {
        // avatar-only puck; it exactly fills the collapsed rail content box
        trigger: 'size-11 justify-center rounded-full',
        text: 'sr-only',
      },
      false: {
        trigger: 'w-full gap-2.5 rounded-xl p-2',
      },
    },
  },
  defaultVariants: {
    compact: false,
  },
});
